import { createEvent, sample } from 'effector'

import { fx } from '../../../../libs'
import { Chargeback, ChargebackPayload } from '../types'

export const createChargebackMounted = createEvent<ChargebackPayload>()

export const createChargeback = fx<ChargebackPayload, Chargeback>({
  method: 'POST',
  url: `/finance/chargeback`,
})

sample({
  clock: createChargebackMounted,
  fn: (body) => ({ body }),
  target: createChargeback,
})
